import { render } from "./BuyerReport.vue?vue&type=template&id=201fb4f4&scoped=true"
import script from "./BuyerReport.vue?vue&type=script&lang=js"
export * from "./BuyerReport.vue?vue&type=script&lang=js"

import "./BuyerReport.vue?vue&type=style&index=0&id=201fb4f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-201fb4f4"]])

export default __exports__